import { timestampsMap } from "./timestamps";

export const demarcationsMap: GenericObject = {
	demarcable_id: "demarcableId",
	demarcable_type: "demarcableType",
	image_id: "imageId",
	...timestampsMap,
};
